import { styled } from "@material-ui/core";

export const Container = styled("div")({
  maxWidth: "1126px",
  margin: "0 auto",
  width: "100%",
  padding: "0",
});
